import { Core } from "@/core/Core";

export default {

  /* Categories */

  async getCategories(context, {inventoryId, augment}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/categories`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getCategory(context, {inventoryId, categoryId, version}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/categories/${categoryId}`, {version});
    } catch (e) {
      return null;
    }
  },

  async saveCategory(context, {inventoryId, categoryId, version, data}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("PUT", `/api/inventory/${inventoryId}/categories/${categoryId}${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async createCategory(context, {inventoryId, data, version}) {
    try {
      let query = version ? `?version=${version}` : '';
      return await Core.request("POST", `/api/inventory/${inventoryId}/categories${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async deleteCategory(context, {inventoryId, categoryId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/categories/" + categoryId);
    } catch (e) {
      return null;
    }
  }

}